import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

//style
import '../../assets/css/errors.css'

//images
import notFound from '../../assets/images/errors/403.png';

function Unauthorised() {

    const showLogin = () => {
        document.getElementById('show-login').click();
    }

    return (
        <>
            <div className="basic basic-special"></div>

            <main id="errors" className="e403">

                <div className="wrapper">
                    <img src={notFound} alt="error" />
                    <h1>
                        Моля, влезте в системата!
                </h1>
                    <p>
                        Моля, влезте в профила си за да видите съдържанието на текущата страница
                </p>
                    <div className="buttons">
                        <Button className="transparent">
                            <Link to="/">
                                Начало
                        </Link>
                        </Button>
                        <Button onClick={showLogin}>
                            <Link>
                                Вход
                        </Link>
                        </Button>
                    </div>
                </div>
            </main>
        </>
    )
}

export default Unauthorised;